<script>

    import Tracking from '../trackings/tracking.svelte'

    export let params = {}

</script>

<Tracking {params} />